import { useEffect, useState } from 'react';

import { AirportSearchViewModel } from '@api/index';
import { FLIGHT_PAST_SEARCH } from '@constants/constants';

export interface IPastSearchFlightItem {
  arr: AirportSearchViewModel;
  dep: AirportSearchViewModel;
}
export const useFlightPastSearches = () => {
  const [pastFlightItems, setPastFlightItems] =
    useState<Array<AirportSearchViewModel>>();

  useEffect(() => {
    const pastItems =
      typeof window !== 'undefined' && localStorage.getItem(FLIGHT_PAST_SEARCH)
        ? JSON.parse(localStorage.getItem(FLIGHT_PAST_SEARCH) || '')
        : [];

    if (typeof window !== 'undefined') {
      localStorage.setItem(FLIGHT_PAST_SEARCH, JSON.stringify(pastItems));
    }
    setPastFlightItems(pastItems);
  }, []);

  const saveFlightSearch = ({ arr, dep }: IPastSearchFlightItem) => {
    let flightItems: AirportSearchViewModel[] = [];

    flightItems = pastFlightItems ? [...pastFlightItems] : [];

    const newDestinations = [arr, dep];

    if (
      !flightItems.find((i) => i.airportCode === newDestinations[0].airportCode)
    ) {
      flightItems.unshift(newDestinations[0]);
    } else {
      const target = flightItems.find(
        (i) => i.airportCode === newDestinations[0].airportCode
      );

      const targetIndex = target ? flightItems.indexOf(target) : -1;

      flightItems.splice(targetIndex, 1);
      flightItems.unshift(newDestinations[0]);
    }

    //deperture

    if (
      !flightItems.find((i) => i.airportCode === newDestinations[1].airportCode)
    ) {
      flightItems.unshift(newDestinations[1]);
    } else {
      const target = flightItems.find(
        (i) => i.airportCode === newDestinations[1].airportCode
      );

      const targetIndex = target ? flightItems.indexOf(target) : -1;

      flightItems.splice(targetIndex, 1);
      flightItems.unshift(newDestinations[1]);
    }

    if (typeof window !== 'undefined') {
      localStorage.setItem(FLIGHT_PAST_SEARCH, JSON.stringify(flightItems));
      setPastFlightItems(flightItems);
    }
  };

  const clearPastFlightSearch = () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(FLIGHT_PAST_SEARCH);
      setPastFlightItems([]);
    }
  };

  const removePastFlightSearch = (item: AirportSearchViewModel) => {
    const newItems = pastFlightItems?.filter(
      (i: AirportSearchViewModel) => i.airportCode !== item.airportCode
    );

    setPastFlightItems(newItems);

    if (typeof window !== 'undefined')
      localStorage.setItem(FLIGHT_PAST_SEARCH, JSON.stringify(newItems));
  };

  return {
    pastFlightItems,
    saveFlightSearch,
    clearPastFlightSearch,
    removePastFlightSearch,
  };
};
